import {
  ActionIcon,
  AppShell,
  Burger,
  Group,
  Tooltip,
  Image,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Nav } from "./Nav/Nav";
import { IconLogout } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import Logo from "../../Assets/SVG/Logo.svg";
import { useRecoilState } from "recoil";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { Colors } from "../../global";

export function Shell({ children }) {
  const [opened, { toggle }] = useDisclosure();
  const { signOut } = useAuthenticator((context) => [context.user]);
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);

  // Sign Out Function: Sign Out User & Clear Recoil State
  const handleSignOut = () => {
    signOut();
    setAllSites({});
  };

  return (
    <AppShell
      header={{ height: { base: 75, md: 80, lg: 90 } }}
      navbar={{
        width: { base: 200, md: 200, lg: 300 },
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group
          h="100%"
          px="xl"
          justify="space-between"
          wrap={false}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Group wrap={false}>
            <Burger
              opened={opened}
              onClick={toggle}
              hiddenFrom="sm"
              size="sm"
            />

            <Image src={Logo} w={{ base: 150, md: 175, lg: 300 }} h="auto" />
          </Group>

          <Tooltip label="Sign Out">
            <ActionIcon
              color={Colors.main}
              onClick={handleSignOut}
              variant="subtle"
              size="lg"
            >
              <IconLogout />
            </ActionIcon>
          </Tooltip>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        <Nav close={toggle} openedMobile={opened} />
      </AppShell.Navbar>

      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
}
